import { BatteryChargingIcon, DropletsIcon, GraduationCapIcon, SunIcon, WindIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fondamenti delle Energie Rinnovabili: Energia, Conversione e Sistemi',
    summary: "Che cos'è l'energia, fonti rinnovabili e non rinnovabili, potenza ed energia (kW e kWh), unità e conversioni, la catena di conversione, effetto serra e ciclo del carbonio, rendimento, fattore di capacità e il sistema elettrico.",
    icon: ZapIcon,
  },
  {
    number: '2',
    title: 'Energia Solare: Fotovoltaico e Solare Termico',
    summary: 'Radiazione solare e irraggiamento, effetto fotovoltaico, celle, moduli e stringhe, curva I-V e scheda tecnica, impianti on-grid e off-grid, dimensionamento, collettori solari e solare termico.',
    icon: SunIcon,
  },
  {
    number: '3',
    title: "Energia Eolica: dal Vento all'Elettricità",
    summary: 'Come nasce il vento, misurarlo e la scala di Beaufort, la formula della potenza del vento, il limite di Betz, pale e rotore, anatomia di una turbina, curva di potenza, parchi eolici a terra e in mare, minieolico.',
    icon: WindIcon,
  },
  {
    number: '4',
    title: 'Acqua, Terra e Biomassa',
    summary: 'Idroelettrico e tipi di turbine, energia delle maree e del moto ondoso, geotermia e pompe di calore, biomassa, biogas e biocarburanti, sostenibilità e confronto tra le fonti programmabili.',
    icon: DropletsIcon,
  },
  {
    number: '5',
    title: 'Accumulo, Smart Grid e Rinnovabili nel Mondo Reale',
    summary: 'Produzione e consumo non coincidono, batterie e pompaggio, idrogeno come vettore, la rete elettrica e le smart grid, microreti e comunità energetiche, autoconsumo, auto elettrica e casi pratici.',
    icon: BatteryChargingIcon,
  },
  {
    number: '6',
    title: 'Insegnare le Energie Rinnovabili',
    summary: 'Obiettivi e struttura delle lezioni, unità di apprendimento pronte, laboratorio sicuro, didattica per problemi, lavoro di gruppo, valutazione per competenze con rubriche, educazione civica, orientamento e lezioni pronte.',
    icon: GraduationCapIcon,
  },
];
